import { BUILD_ID } from "../appVersion";

export type RemoteAppVersion = {
  version: string;
  buildId: string;
  builtAt?: string;
};

export function getAppVersionJsonUrl(): string {
  const base = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
  const path = `${base}/app-version.json`.replace(/^\/{2,}/, "/");
  return path.startsWith("/") ? path : `/${path}`;
}

export async function fetchRemoteAppVersion(): Promise<RemoteAppVersion | null> {
  try {
    const url = `${getAppVersionJsonUrl()}?cb=${Date.now()}`;
    const r = await fetch(url, { cache: "no-store", credentials: "same-origin" });
    if (!r.ok) return null;
    const j = (await r.json()) as Record<string, unknown>;
    if (!j || typeof j.buildId !== "string") return null;
    return {
      version: typeof j.version === "string" ? j.version : "",
      buildId: j.buildId,
      builtAt: typeof j.builtAt === "string" ? j.builtAt : undefined,
    };
  } catch {
    return null;
  }
}

/** true — на сервере другая сборка, чем в этом клиентском бандле. */
export function isClientBuildOutdated(remote: RemoteAppVersion | null): boolean {
  if (!remote) return false;
  return BUILD_ID !== remote.buildId;
}
